var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 79,
    viewBox: "0 0 70 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1896_3610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.688 23.3135C69.6874 22.0023 69.407 20.8436 68.8399 19.8495C68.2828 18.8713 67.4485 18.0517 66.3295 17.4037C57.0925 12.0776 47.8465 6.76777 38.6124 1.43622C36.123 -0.000980794 33.7093 0.051686 31.2383 1.50952C27.5617 3.67754 9.1541 14.2236 3.66889 17.4007C1.40993 18.7087 0.310713 20.7101 0.31017 23.3111C0.306641 34.0222 0.31017 44.7334 0.306641 55.4445C0.306641 56.727 0.575675 57.8634 1.11782 58.8426C1.67516 59.8501 2.52108 60.6922 3.66591 61.3549C9.15139 64.532 27.5614 75.0773 31.2372 77.2461C33.7093 78.7048 36.123 78.7569 38.6132 77.3194C47.8476 71.9876 57.0941 66.6778 66.3325 61.3516C67.4773 60.6892 68.3232 59.8466 68.8806 58.8399C69.4219 57.8604 69.6915 56.7243 69.6915 55.4416C69.6915 55.4416 69.6915 34.025 69.688 23.3135Z",
    fill: "#A179DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1065 39.2754L1.11914 58.8446C1.67648 59.852 2.52241 60.6942 3.66723 61.3568C9.15271 64.534 27.5627 75.0792 31.2385 77.2481C33.7106 78.7067 36.1243 78.7589 38.6146 77.3214C47.8489 71.9896 57.0954 66.6797 66.3338 61.3536C67.4786 60.6912 68.3246 59.8485 68.8819 58.8419L35.1065 39.2754Z",
    fill: "#280068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6882 23.3137C69.6877 22.0024 69.4072 20.8438 68.8401 19.8496L35.1055 39.2738L68.8808 58.8401C69.4222 57.8606 69.6912 56.7244 69.6917 55.4417C69.6917 55.4417 69.6917 34.0251 69.6882 23.3137Z",
    fill: "#390091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1174 31.959V35.6169H58.7753V31.959H60.6043V35.6169H64.2621V37.4458H60.6043V41.1034H64.2621V42.9324H60.6043V46.5903H58.7753V42.9324H55.1174V46.5903H53.2885V42.9324H49.6309V41.1034H53.2885V37.4458H49.6309V35.6169H53.2885V31.959H55.1174ZM58.7753 37.4455H55.1174V41.1034H58.7753V37.4455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1813 13.5882C44.7221 13.5882 53.0519 18.7696 57.5136 26.4714L57.4702 26.3973L46.2445 32.8606C44.0331 29.1161 39.9788 26.589 35.3276 26.5368L35.181 26.536C28.0887 26.536 22.3388 32.2859 22.3388 39.3783C22.3364 41.6137 22.9204 43.8107 24.0325 45.7499C26.2461 49.6143 30.4076 52.2208 35.1813 52.2208C39.9845 52.2208 44.1696 49.5812 46.3719 45.6755L46.3184 45.7691L57.5269 52.2623C53.114 59.899 44.8983 65.0644 35.4685 65.1673L35.1813 65.1689C25.6103 65.1689 17.257 59.9555 12.8064 52.2129C10.6337 48.4331 9.39062 44.0512 9.39062 39.3783C9.39062 25.1349 20.9371 13.5879 35.181 13.5879L35.1813 13.5882Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1896_3610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 78.7579,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode8);
export default __webpack_public_path__ + "static/media/code8.41bb1b8c6c3cd7aa02e9cf6bdf7a1358.svg";
export { ForwardRef as ReactComponent };